import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const { format: formatDate } = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', });

const DESCRIPTION_MAX_LENGTH = 100;

function truncate(text, maxLength) {
  if (!text || text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trimEnd()}...`;
}

const useStyles = makeStyles(() => ({
  headerCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    whiteSpace: 'nowrap',
  },
}));

export function ChangeLogTable({ changeLog }) {
  const classes = useStyles();

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell className={classes.headerCell}>Questão</TableCell>
          <TableCell className={classes.headerCell} align="center">Resposta Anterior</TableCell>
          <TableCell className={classes.headerCell} align="center">Nova Resposta</TableCell>
          <TableCell className={classes.headerCell}>Editado em</TableCell>
          <TableCell className={classes.headerCell}>Editado por</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {changeLog.map((entry, idx) => (
          <TableRow key={`${entry.questionCode}-${entry.changedAt}-${idx}`}>
            <TableCell>
              <Typography variant="body2" title={entry.questionDescription}>
                {entry.questionCode} - {truncate(entry.questionDescription, DESCRIPTION_MAX_LENGTH)}
              </Typography>
            </TableCell>
            <TableCell className={classes.bodyCell} align="center">{entry.oldAnswerLetter ?? '-'}</TableCell>
            <TableCell className={classes.bodyCell} align="center">{entry.newAnswerLetter ?? '-'}</TableCell>
            <TableCell className={classes.bodyCell}>
              {entry.changedAt ? formatDate(new Date(entry.changedAt)) : '-'}
            </TableCell>
            <TableCell className={classes.bodyCell}>{entry.changedBy ?? '-'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
